import { Bell } from 'lucide-react';
import { tr } from '../../lib/i18n.ts';
import { Popover } from '../Popover.tsx';
import { selectUnreadCount, useNotifications } from '../notifications.ts';
import type { WidgetVariant } from './types.ts';

export function BellWidget({ variant }: { variant: WidgetVariant }) {
  const unread = useNotifications(selectUnreadCount);
  const items = useNotifications((state) => state.items);
  const label = unread > 0 ? tr.infobar.unread(unread) : tr.infobar.notifications;
  return (
    <div className="iw iw-bell" data-variant={variant}>
      <Popover
        label={label}
        triggerClassName="infobar-button"
        trigger={
          <>
            <Bell size={17} aria-hidden />
            {unread > 0 && <span className="bell-dot" aria-hidden />}
          </>
        }
      >
        {() => (
          <div className="notification-list">
            <h2 className="popover-title">{tr.infobar.notifications}</h2>
            {items.length === 0 ? (
              <p className="popover-empty">{tr.infobar.noNotifications}</p>
            ) : (
              <>
                <ul>
                  {items.map((item) => (
                    <li key={item.id}>{item.title}</li>
                  ))}
                </ul>
                <button type="button" className="btn" onClick={() => useNotifications.getState().markAllRead()}>
                  {tr.infobar.markAllRead}
                </button>
              </>
            )}
          </div>
        )}
      </Popover>
    </div>
  );
}
